var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Loading", { attrs: { active: _vm.loading, "is-full-page": true } }),
      _c(
        "div",
        { staticClass: "pa-3", attrs: { align: "center", justify: "center" } },
        [
          _c(
            "v-card",
            { staticClass: "mb-3", attrs: { align: "left", justify: "left" } },
            [
              _c(
                "v-card-text",
                { staticClass: "pa-3 font-weight-light white black--text" },
                [
                  _c(
                    "v-icon",
                    { staticClass: "primary--text lighten-2 pa-2" },
                    [_vm._v(" mdi-webhook ")]
                  ),
                  _vm._v(" Relatórios > Monitoramento de Webhooks ")
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card",
            { staticClass: "pa-3 mb-4" },
            [
              _c(
                "v-row",
                { staticClass: "pa-3 d-flex align-center" },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "3" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          type: "date",
                          label: "Data inicial",
                          outlined: "",
                          dense: "",
                          "hide-details": "",
                          disabled: _vm.loading,
                          "data-cy": "filtroDataInicio"
                        },
                        model: {
                          value: _vm.filtroDataInicio,
                          callback: function($$v) {
                            _vm.filtroDataInicio = $$v
                          },
                          expression: "filtroDataInicio"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "3" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          type: "date",
                          label: "Data final",
                          outlined: "",
                          dense: "",
                          "hide-details": "",
                          disabled: _vm.loading,
                          "data-cy": "filtroDataFim"
                        },
                        model: {
                          value: _vm.filtroDataFim,
                          callback: function($$v) {
                            _vm.filtroDataFim = $$v
                          },
                          expression: "filtroDataFim"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "2" } },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.statusOptions,
                          "item-text": "name",
                          "item-value": "value",
                          label: "Status",
                          outlined: "",
                          dense: "",
                          "hide-details": "",
                          clearable: "",
                          disabled: _vm.loading,
                          "data-cy": "filtroStatus"
                        },
                        model: {
                          value: _vm.filtroStatus,
                          callback: function($$v) {
                            _vm.filtroStatus = $$v
                          },
                          expression: "filtroStatus"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "2" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "ID Título",
                          type: "number",
                          outlined: "",
                          dense: "",
                          "hide-details": "",
                          disabled: _vm.loading,
                          "data-cy": "filtroIdTitulo"
                        },
                        model: {
                          value: _vm.filtroIdTitulo,
                          callback: function($$v) {
                            _vm.filtroIdTitulo = $$v
                          },
                          expression: "filtroIdTitulo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "2" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Nosso Número",
                          outlined: "",
                          dense: "",
                          "hide-details": "",
                          disabled: _vm.loading,
                          "data-cy": "filtroNossoNumero"
                        },
                        model: {
                          value: _vm.filtroNossoNumero,
                          callback: function($$v) {
                            _vm.filtroNossoNumero = $$v
                          },
                          expression: "filtroNossoNumero"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "pa-3 d-flex align-center" },
                [
                  _vm.isSuperUser
                    ? _c(
                        "v-col",
                        { attrs: { cols: "12", md: "2" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              items: _vm.apresentantes,
                              "item-text": item =>
                                `${item.cd_apresentante} - ${item.nm_apresentante}`,
                              filter: _vm.customFilterApresentante,
                              "item-value": "cd_apresentante",
                              label: "Apresentante (sigla ou nome)",
                              outlined: "",
                              dense: "",
                              "hide-details": "",
                              clearable: "",
                              loading: _vm.loading || _vm.loadingApresentantes,
                              disabled: _vm.loading,
                              "data-cy": "filtroCdApresentante"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "item",
                                  fn: function(data) {
                                    return [
                                      _c(
                                        "v-list-item-content",
                                        [
                                          _c("v-list-item-title", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  data.item.nm_apresentante
                                                ) +
                                                " "
                                            )
                                          ]),
                                          _c("v-list-item-subtitle", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  data.item.cd_apresentante
                                                ) +
                                                " "
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              520926143
                            ),
                            model: {
                              value: _vm.filtroCdApresentante,
                              callback: function($$v) {
                                _vm.filtroCdApresentante = $$v
                              },
                              expression: "filtroCdApresentante"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "v-col",
                    { staticClass: "d-flex justify-end align-center pa-3" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "mr-2",
                          attrs: {
                            color: "info",
                            disabled: _vm.loading,
                            "data-cy": "btnFiltrar"
                          },
                          on: { click: _vm.aplicarFiltros }
                        },
                        [
                          _c("v-icon", { attrs: { left: "" } }, [
                            _vm._v("mdi-magnify")
                          ]),
                          _vm._v(" Filtrar ")
                        ],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "mr-2",
                          attrs: {
                            outlined: "",
                            color: "secondary",
                            disabled: _vm.loading,
                            "data-cy": "btnLimpar"
                          },
                          on: { click: _vm.limparFiltros }
                        },
                        [
                          _c("v-icon", { attrs: { left: "" } }, [
                            _vm._v("mdi-filter-remove")
                          ]),
                          _vm._v(" Limpar ")
                        ],
                        1
                      ),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { top: "" },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function({ on, attrs }) {
                                return [
                                  _vm.isSuperUser
                                    ? _c(
                                        "v-btn",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass: "mr-2",
                                              attrs: {
                                                color: "warning",
                                                disabled: _vm.loading,
                                                "data-cy": "btnDispatcher"
                                              },
                                              on: {
                                                click:
                                                  _vm.abrirConfirmacaoDispatcher
                                              }
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { left: "" } },
                                            [_vm._v("mdi-play-circle")]
                                          ),
                                          _vm._v(" Rodar Dispatcher ")
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ]
                              }
                            }
                          ])
                        },
                        [
                          _c("span", [
                            _vm._v(
                              "Busca webhooks elegíveis e dispara o webhook-handler Lambda"
                            )
                          ])
                        ]
                      ),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { top: "" },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function({ on, attrs }) {
                                return [
                                  _vm.isSuperUser
                                    ? _c(
                                        "v-btn",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass: "mr-2",
                                              attrs: {
                                                color: "error",
                                                disabled: _vm.loading,
                                                "data-cy": "btnWatchdog"
                                              },
                                              on: {
                                                click:
                                                  _vm.abrirConfirmacaoWatchdog
                                              }
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { left: "" } },
                                            [_vm._v("mdi-shield-refresh")]
                                          ),
                                          _vm._v(" Rodar Watchdog ")
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ]
                              }
                            }
                          ])
                        },
                        [
                          _c("span", [
                            _vm._v(
                              'Reclassifica webhooks presos em "processing" para "pending"'
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card",
            { staticClass: "pa-3" },
            [
              _vm.isSuperUser
                ? _c(
                    "v-toolbar",
                    {
                      staticClass: "mb-2",
                      attrs: { flat: "", dense: "", "data-cy": "toolbarLote" }
                    },
                    [
                      _c("v-icon", { attrs: { left: "", color: "info" } }, [
                        _vm._v("mdi-checkbox-multiple-marked")
                      ]),
                      _vm.selecionarTodosFiltrados
                        ? _c(
                            "span",
                            { attrs: { "data-cy": "textoSelecaoLote" } },
                            [
                              _vm._v(" Todos os "),
                              _c("b", { staticClass: "mx-1" }, [
                                _vm._v(_vm._s(_vm.totalItems))
                              ]),
                              _vm._v(" webhooks filtrados selecionados ")
                            ]
                          )
                        : _vm.selecionados.length
                        ? _c(
                            "span",
                            { attrs: { "data-cy": "textoSelecaoLote" } },
                            [
                              _c("b", [
                                _vm._v(_vm._s(_vm.selecionados.length))
                              ]),
                              _vm._v(" webhook(s) selecionado(s) "),
                              _vm.qtdFailedSelecionados !==
                              _vm.selecionados.length
                                ? _c("span", { staticClass: "ml-1" }, [
                                    _vm._v(
                                      " (" +
                                        _vm._s(_vm.qtdFailedSelecionados) +
                                        " com status failed) "
                                    )
                                  ])
                                : _vm._e()
                            ]
                          )
                        : _c(
                            "span",
                            {
                              staticClass: "grey--text",
                              attrs: { "data-cy": "textoSelecaoLote" }
                            },
                            [
                              _vm._v(
                                " Selecione webhooks pelos checkboxes para reprocessar em lote "
                              )
                            ]
                          ),
                      _c("v-spacer"),
                      !_vm.selecionarTodosFiltrados &&
                      _vm.totalItems > 0 &&
                      _vm.totalItems > _vm.selecionados.length
                        ? _c(
                            "v-btn",
                            {
                              attrs: {
                                text: "",
                                small: "",
                                color: "info",
                                disabled: _vm.loading,
                                "data-cy": "btnSelecionarTodosFiltrados"
                              },
                              on: { click: _vm.ativarSelecaoTodosFiltrados }
                            },
                            [
                              _vm._v(
                                " Selecionar todos os " +
                                  _vm._s(_vm.totalItems) +
                                  " filtrados "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm.selecionarTodosFiltrados || _vm.selecionados.length
                        ? _c(
                            "v-btn",
                            {
                              attrs: {
                                text: "",
                                small: "",
                                color: "grey",
                                disabled: _vm.loading,
                                "data-cy": "btnLimparSelecao"
                              },
                              on: { click: _vm.limparSelecaoLote }
                            },
                            [_vm._v(" Limpar seleção ")]
                          )
                        : _vm._e(),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "info",
                            small: "",
                            disabled:
                              _vm.loading ||
                              (!_vm.selecionarTodosFiltrados &&
                                !_vm.selecionados.length),
                            "data-cy": "btnReprocessarLote"
                          },
                          on: { click: _vm.abrirConfirmacaoLote }
                        },
                        [
                          _c("v-icon", { attrs: { left: "", small: "" } }, [
                            _vm._v("mdi-replay")
                          ]),
                          _vm._v(
                            " Reprocessar em lote" +
                              _vm._s(
                                _vm.selecionarTodosFiltrados
                                  ? ` (${_vm.totalItems})`
                                  : _vm.selecionados.length
                                  ? ` (${_vm.selecionados.length})`
                                  : ""
                              ) +
                              " "
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c("v-data-table", {
                staticClass: "elevation-1",
                attrs: {
                  headers: _vm.headers,
                  items: _vm.webhooks,
                  loading: _vm.loading,
                  "footer-props": {
                    itemsPerPageOptions: [10, 20, 50, 100],
                    itemsPerPageText: "Itens por página:"
                  },
                  "item-key": "id",
                  "server-items-length": _vm.totalItems,
                  page: _vm.currentPage,
                  "items-per-page": _vm.itemsPerPage,
                  "show-select": _vm.isSuperUser
                },
                on: {
                  "update:page": [
                    function($event) {
                      _vm.currentPage = $event
                    },
                    _vm.carregarDados
                  ],
                  "update:itemsPerPage": function($event) {
                    _vm.itemsPerPage = $event
                  },
                  "update:items-per-page": [
                    function($event) {
                      _vm.itemsPerPage = $event
                    },
                    _vm.carregarDados
                  ],
                  "click:row": _vm.abrirDetalhe,
                  "toggle-select-all": _vm.aoAlternarSelecaoPagina
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: `item.status`,
                      fn: function({ item }) {
                        return [
                          _c(
                            "v-chip",
                            {
                              attrs: {
                                color: _vm.statusColor(item.status),
                                small: "",
                                dark: ""
                              }
                            },
                            [_vm._v(" " + _vm._s(item.status) + " ")]
                          )
                        ]
                      }
                    },
                    {
                      key: `header.next_attempt_at`,
                      fn: function() {
                        return [
                          _c(
                            "span",
                            [
                              _vm._v(" Próxima tentativa "),
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "activator",
                                      fn: function({ on, attrs }) {
                                        return [
                                          _c(
                                            "v-icon",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass: "ml-1",
                                                  attrs: {
                                                    small: "",
                                                    color: "info"
                                                  }
                                                },
                                                "v-icon",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [_vm._v("mdi-information")]
                                          )
                                        ]
                                      }
                                    }
                                  ])
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      "Pode levar de 5 a 9 minutos para ser enviado aproximadamente."
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      },
                      proxy: true
                    },
                    {
                      key: `item.next_attempt_at`,
                      fn: function({ item }) {
                        return [
                          item.status !== "success" && item.attempts < 3
                            ? _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.formatarDataHoraUtcMinus3(
                                        item.next_attempt_at
                                      )
                                    ) +
                                    " "
                                )
                              ])
                            : _vm._e()
                        ]
                      }
                    },
                    {
                      key: `item.last_attempt_at`,
                      fn: function({ item }) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.formatarDataHoraUtcMinus3(
                                  item.last_attempt_at
                                )
                              ) +
                              " "
                          )
                        ]
                      }
                    },
                    {
                      key: `item.created_at`,
                      fn: function({ item }) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.formatarDataHoraUtcMinus3(item.created_at)
                              ) +
                              " "
                          )
                        ]
                      }
                    },
                    {
                      key: `item.updated_at`,
                      fn: function({ item }) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.formatarDataHoraUtcMinus3(item.updated_at)
                              ) +
                              " "
                          )
                        ]
                      }
                    },
                    {
                      key: `item.acoes`,
                      fn: function({ item }) {
                        return [
                          _c(
                            "div",
                            { staticClass: "d-flex align-center" },
                            [
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { top: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function({ on, attrs }) {
                                          return [
                                            _c(
                                              "v-btn",
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    attrs: {
                                                      icon: "",
                                                      small: "",
                                                      color: "grey darken-1",
                                                      "data-cy": "btnVerDetalhe"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        return _vm.abrirDetalhe(
                                                          item
                                                        )
                                                      }
                                                    }
                                                  },
                                                  "v-btn",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [
                                                _c(
                                                  "v-icon",
                                                  { attrs: { small: "" } },
                                                  [_vm._v("mdi-eye")]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                },
                                [
                                  _c("span", [
                                    _vm._v("Ver detalhes do webhook")
                                  ])
                                ]
                              ),
                              _vm.isSuperUser
                                ? _c(
                                    "v-tooltip",
                                    {
                                      attrs: { top: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function({ on, attrs }) {
                                              return [
                                                _c(
                                                  "v-btn",
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        staticClass: "ml-1",
                                                        attrs: {
                                                          icon: "",
                                                          small: "",
                                                          color: "info",
                                                          "data-cy":
                                                            "btnReprocessar"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.abrirConfirmacaoReprocessar(
                                                              item
                                                            )
                                                          }
                                                        }
                                                      },
                                                      "v-btn",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      { attrs: { small: "" } },
                                                      [_vm._v("mdi-replay")]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          "Reprocessar webhook (zera tentativas e volta para pending)"
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  true
                ),
                model: {
                  value: _vm.selecionados,
                  callback: function($$v) {
                    _vm.selecionados = $$v
                  },
                  expression: "selecionados"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "900", scrollable: "" },
          model: {
            value: _vm.dialogDetalhe,
            callback: function($$v) {
              _vm.dialogDetalhe = $$v
            },
            expression: "dialogDetalhe"
          }
        },
        [
          _vm.webhookDetalhe
            ? _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    { staticClass: "headline" },
                    [
                      _vm._v(
                        " Webhook #" + _vm._s(_vm.webhookDetalhe.id) + " "
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-chip",
                        {
                          attrs: {
                            color: _vm.statusColor(_vm.webhookDetalhe.status),
                            dark: "",
                            small: ""
                          }
                        },
                        [_vm._v(" " + _vm._s(_vm.webhookDetalhe.status) + " ")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-row",
                        [
                          _c("v-col", { attrs: { cols: "12", md: "6" } }, [
                            _c("div", [
                              _c("b", [_vm._v("Apresentante:")]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.webhookDetalhe.cd_apresentante) +
                                  " (id " +
                                  _vm._s(_vm.webhookDetalhe.apresentante_id) +
                                  ")"
                              )
                            ]),
                            _c("div", [
                              _c("b", [_vm._v("Tipo:")]),
                              _vm._v(" " + _vm._s(_vm.webhookDetalhe.type))
                            ]),
                            _c("div", [
                              _c("b", [_vm._v("ID Título:")]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.webhookDetalhe.id_titulo || "-")
                              )
                            ]),
                            _c("div", [
                              _c("b", [_vm._v("Tentativas:")]),
                              _vm._v(" " + _vm._s(_vm.webhookDetalhe.attempts))
                            ]),
                            _c("div", [
                              _c("b", [_vm._v("Último status code:")]),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.webhookDetalhe.last_status_code || "-"
                                  )
                              )
                            ])
                          ]),
                          _c("v-col", { attrs: { cols: "12", md: "6" } }, [
                            _c("div", [
                              _c("b", [_vm._v("Criado em:")]),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.formatarDataHoraUtcMinus3(
                                      _vm.webhookDetalhe.created_at
                                    )
                                  )
                              )
                            ]),
                            _c("div", [
                              _c("b", [_vm._v("Atualizado em:")]),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.formatarDataHoraUtcMinus3(
                                      _vm.webhookDetalhe.updated_at
                                    )
                                  )
                              )
                            ]),
                            _vm.webhookDetalhe.status !== "success" &&
                            _vm.webhookDetalhe.attempts < 3
                              ? _c("div", [
                                  _c("b", [_vm._v("Próxima tentativa:")]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.formatarDataHoraUtcMinus3(
                                          _vm.webhookDetalhe.next_attempt_at
                                        )
                                      )
                                  )
                                ])
                              : _vm._e(),
                            _c("div", [
                              _c("b", [_vm._v("Última tentativa:")]),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.formatarDataHoraUtcMinus3(
                                      _vm.webhookDetalhe.last_attempt_at
                                    )
                                  )
                              )
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm.webhookDetalhe.last_message &&
                      ["skipped", "failed"].includes(_vm.webhookDetalhe.status)
                        ? _c(
                            "v-alert",
                            {
                              staticClass: "mt-3",
                              attrs: {
                                type:
                                  _vm.webhookDetalhe.status === "skipped"
                                    ? "warning"
                                    : "error",
                                dense: "",
                                outlined: ""
                              }
                            },
                            [
                              _c("b", [_vm._v("Motivo:")]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.webhookDetalhe.last_message) +
                                  " "
                              )
                            ]
                          )
                        : _vm._e(),
                      _c("v-divider", { staticClass: "my-3" }),
                      _c("div", { staticClass: "subtitle-1 mb-2" }, [
                        _vm._v("Payload")
                      ]),
                      _c("pre", { staticClass: "payload-pre" }, [
                        _vm._v(
                          _vm._s(
                            JSON.stringify(_vm.webhookDetalhe.payload, null, 2)
                          )
                        )
                      ]),
                      _c("v-divider", { staticClass: "my-3" }),
                      _c("div", { staticClass: "subtitle-1 mb-2" }, [
                        _vm._v(
                          "Histórico de tentativas (" +
                            _vm._s(_vm.tentativas.length) +
                            ")"
                        )
                      ]),
                      _vm.tentativas.length
                        ? _c("v-data-table", {
                            staticClass: "elevation-1",
                            attrs: {
                              headers: _vm.headersTentativas,
                              items: _vm.tentativas,
                              "items-per-page": 10,
                              "sort-by": "started_at",
                              "sort-desc": true
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: `item.started_at`,
                                  fn: function({ item }) {
                                    return [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.formatarDataHoraUtcMinus3(
                                              item.started_at
                                            )
                                          ) +
                                          " "
                                      )
                                    ]
                                  }
                                },
                                {
                                  key: `item.finished_at`,
                                  fn: function({ item }) {
                                    return [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.formatarDataHoraUtcMinus3(
                                              item.finished_at
                                            )
                                          ) +
                                          " "
                                      )
                                    ]
                                  }
                                },
                                {
                                  key: `item.status_code`,
                                  fn: function({ item }) {
                                    return [
                                      item.status_code
                                        ? _c(
                                            "v-chip",
                                            {
                                              attrs: {
                                                color: _vm.statusCodeColor(
                                                  item.status_code
                                                ),
                                                small: "",
                                                dark: ""
                                              }
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(item.status_code) +
                                                  " "
                                              )
                                            ]
                                          )
                                        : _c("span", [_vm._v("-")])
                                    ]
                                  }
                                },
                                {
                                  key: `item.response_body`,
                                  fn: function({ item }) {
                                    return [
                                      item.response_body
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "response-cell",
                                              on: {
                                                click: function($event) {
                                                  return _vm.copiarTexto(
                                                    item.response_body
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  item.response_body.substring(
                                                    0,
                                                    80
                                                  )
                                                ) +
                                                  _vm._s(
                                                    item.response_body.length >
                                                      80
                                                      ? "..."
                                                      : ""
                                                  )
                                              )
                                            ]
                                          )
                                        : _c("span", [_vm._v("-")])
                                    ]
                                  }
                                },
                                {
                                  key: `item.response_headers`,
                                  fn: function({ item }) {
                                    return [
                                      item.response_headers
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "response-cell",
                                              on: {
                                                click: function($event) {
                                                  _vm.copiarTexto(
                                                    JSON.stringify(
                                                      item.response_headers,
                                                      null,
                                                      2
                                                    )
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  JSON.stringify(
                                                    item.response_headers
                                                  ).substring(0, 60)
                                                ) +
                                                  _vm._s(
                                                    JSON.stringify(
                                                      item.response_headers
                                                    ).length > 60
                                                      ? "..."
                                                      : ""
                                                  )
                                              )
                                            ]
                                          )
                                        : _c("span", [_vm._v("-")])
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          })
                        : _c("div", { staticClass: "pa-3 text-center" }, [
                            _vm._v("Nenhuma tentativa registrada.")
                          ])
                    ],
                    1
                  ),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { text: "" },
                          on: {
                            click: function($event) {
                              _vm.dialogDetalhe = false
                            }
                          }
                        },
                        [_vm._v("Fechar")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500" },
          model: {
            value: _vm.dialogConfirmacao,
            callback: function($$v) {
              _vm.dialogConfirmacao = $$v
            },
            expression: "dialogConfirmacao"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "headline" }, [
                _vm._v(_vm._s(_vm.confirmacao.titulo))
              ]),
              _c(
                "v-card-text",
                { staticStyle: { "white-space": "pre-line" } },
                [_vm._v(_vm._s(_vm.confirmacao.texto))]
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "green darken-1", text: "" },
                      on: { click: _vm.confirmarAcaoJob }
                    },
                    [_vm._v("Confirmar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "red darken-1", text: "" },
                      on: {
                        click: function($event) {
                          _vm.dialogConfirmacao = false
                        }
                      }
                    },
                    [_vm._v("Cancelar")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "550", "data-cy": "dialogLote" },
          model: {
            value: _vm.dialogLote,
            callback: function($$v) {
              _vm.dialogLote = $$v
            },
            expression: "dialogLote"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "headline" }, [
                _vm._v("Reprocessar webhooks em lote?")
              ]),
              _c(
                "v-card-text",
                [
                  _vm.selecionarTodosFiltrados
                    ? _c(
                        "div",
                        { attrs: { "data-cy": "textoConfirmacaoLote" } },
                        [
                          _vm._v(" Tem certeza que deseja reprocessar "),
                          _c("b", [
                            _vm._v(
                              "TODOS os " +
                                _vm._s(_vm.totalItems) +
                                " webhooks filtrados"
                            )
                          ]),
                          _vm._v("? ")
                        ]
                      )
                    : _c(
                        "div",
                        { attrs: { "data-cy": "textoConfirmacaoLote" } },
                        [
                          _vm._v(" Tem certeza que deseja reprocessar os "),
                          _c("b", [
                            _vm._v(
                              _vm._s(_vm.selecionados.length) +
                                " webhook(s) selecionado(s)"
                            )
                          ]),
                          _vm.qtdFailedSelecionados !== _vm.selecionados.length
                            ? _c("span", [
                                _vm._v(
                                  " (" +
                                    _vm._s(_vm.qtdFailedSelecionados) +
                                    " com status failed)"
                                )
                              ])
                            : _vm._e(),
                          _vm._v("? ")
                        ]
                      ),
                  _c(
                    "v-alert",
                    {
                      staticClass: "mt-3",
                      attrs: { type: "info", dense: "", outlined: "" }
                    },
                    [
                      _vm._v(" Apenas webhooks com status "),
                      _c("b", [_vm._v("failed")]),
                      _vm._v(
                        " serão reprocessados. Os demais serão ignorados pelo servidor. "
                      )
                    ]
                  ),
                  _c("div", { staticClass: "mt-2 grey--text text--darken-1" }, [
                    _vm._v(
                      ' Os webhooks serão redefinidos como "pending" com tentativas zeradas e enviados na próxima execução do dispatcher. '
                    )
                  ])
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "green darken-1",
                        text: "",
                        loading: _vm.loading,
                        "data-cy": "btnConfirmarLote"
                      },
                      on: { click: _vm.confirmarReprocessarLote }
                    },
                    [_vm._v("Confirmar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "red darken-1",
                        text: "",
                        "data-cy": "btnCancelarLote"
                      },
                      on: {
                        click: function($event) {
                          _vm.dialogLote = false
                        }
                      }
                    },
                    [_vm._v("Cancelar")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-snackbar",
        {
          attrs: {
            color: _vm.snackbarColor,
            timeout: "5000",
            top: "",
            right: ""
          },
          scopedSlots: _vm._u([
            {
              key: "action",
              fn: function({ attrs }) {
                return [
                  _c(
                    "v-btn",
                    _vm._b(
                      {
                        attrs: { text: "" },
                        on: {
                          click: function($event) {
                            _vm.snackbar = false
                          }
                        }
                      },
                      "v-btn",
                      attrs,
                      false
                    ),
                    [_vm._v("Fechar")]
                  )
                ]
              }
            }
          ]),
          model: {
            value: _vm.snackbar,
            callback: function($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar"
          }
        },
        [_vm._v(" " + _vm._s(_vm.snackbarMessage) + " ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }